import { useState, useEffect } from "react";
import { API_ENDPOINTS } from "../../../api/endpoints";

const useTarifasClientes = () => {
  const [tarifasClientes, setTarifasClientes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [busqueda, setBusqueda] = useState("");

  const fetchTarifasClientes = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(API_ENDPOINTS.interna.SelectAllDataTarifaClient);
      if (!res.ok) throw new Error("Error al obtener datos del servidor");
      const data = await res.json();
      setTarifasClientes(data);
    } catch (err) {
      console.error("Error al cargar TarifasClientes:", err);
      setError("No se pudieron cargar las tarifas por cliente.");
    } finally {
      setLoading(false);
    }
  };

  // En useTarifasClientes.js
  const filtrarTarifasClientes = () => {
    const q = busqueda.toLowerCase();
    return tarifasClientes.filter(
      (item) =>
        item.cliente_nombre?.toLowerCase().includes(q) ||
        item.tarifa_nombre?.toLowerCase().includes(q) || // <--- CAMBIO AQUÍ: de tarifa_tipo_movil a tarifa_nombre
        (item.estado === 1 ? "activo" : "inactivo").includes(q) ||
        item.username?.toLowerCase().includes(q)
    );
  };

  useEffect(() => {
    fetchTarifasClientes();
  }, []);

  return {
    tarifasClientes,
    loading,
    error,
    busqueda,
    setBusqueda,
    filtrarTarifasClientes,
    fetchTarifasClientes,
  };
};

export default useTarifasClientes;
